import React from 'react';
import { Sun, Wind, AlertCircle, Droplets } from 'lucide-react';
export function WeatherBanner() {
  return <div className="bg-gradient-to-r from-sky-dark via-sky to-sky-dark text-white py-3 px-4 md:px-8 text-sm flex flex-col md:flex-row justify-between items-center gap-3 z-40 relative shadow-md border-b border-sky-dark/50" data-id="element-448">
      {/* Condiciones Actuales */}
      <div className="flex flex-wrap items-center justify-center md:justify-start gap-4 md:gap-6 w-full md:w-auto" data-id="element-449">
        <div className="flex items-center gap-2 font-bold text-lg drop-shadow-sm" data-id="element-450">
          <Sun className="w-6 h-6 text-warm animate-[spin_10s_linear_infinite]" data-id="element-451" />
          <span data-id="element-452">Sylmar: 72°F (22°C) Soleado</span>
        </div>

        <div className="hidden md:block w-px h-5 bg-white/30" data-id="element-453"></div>

        <div className="flex items-center gap-2 font-medium text-white/90" data-id="element-454">
          <Wind className="w-5 h-5 text-white" data-id="element-455" />
          <span data-id="element-456">Viento: 15 mph NE</span>
        </div>

        <div className="hidden md:block w-px h-5 bg-white/30" data-id="element-457"></div>

        <div className="flex items-center gap-2 font-medium text-white/90" data-id="element-458">
          <Droplets className="w-5 h-5 text-white" data-id="element-459" />
          <span data-id="element-460">Humedad: 18%</span>
        </div>
      </div>

      {/* Alerta Meteorológica Elegante y Llamativa */}
      <div className="flex items-center gap-2 bg-red-600 text-white px-5 py-1.5 rounded-full border border-red-400 cursor-pointer hover:bg-red-700 transition-colors shadow-[0_0_10px_rgba(220,38,38,0.5)] w-full md:w-auto justify-center mt-2 md:mt-0" data-id="element-461">
        <span className="relative flex h-3 w-3" data-id="element-462">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" data-id="element-463"></span>
          <span className="relative inline-flex rounded-full h-3 w-3 bg-white" data-id="element-464"></span>
        </span>
        <AlertCircle className="w-4 h-4" data-id="element-465" />
        <span className="font-bold tracking-wide text-sm" data-id="element-466">
          Aviso de Bandera Roja (Vientos)
        </span>
      </div>
    </div>;
}